package one.healthium.insights.ui.shopping_list.models

import one.healthium.loco.LString
import androidx.compose.runtime.Immutable

@Immutable
internal data class HeaderUiModel(
    val id: String,
    val text: LString,
    val categories: CategoriesUiModel?,
    val canClear: Boolean = false,
)
